// employee/reducers.ts
const initialState = {
    getReturnOrderData: [],
    getAllReturnOrderData: [],
    getAllReturnOrderSuccess: false,
    getAllReturnOrderFailure: false,
    getReturnOrderCount: null,
    createReturnOrderData: null,
    updateReturnOrderData: null,
    getReturnOrderMetaMessage: null,
    getReturnOrderSuccess: false,
    getReturnOrderFailure: false,
    createReturnOrderSuccess: false,
    createReturnOrderFailure: false,
    updateReturnOrderSuccess: false,
    updateReturnOrderFailure: false,
    deleteReturnOrderSuccess: false,
    deleteReturnOrderFailure: false,
};

export default function ReturnOrderReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_RETURN_ORDER_SUCCESS': {
            return {
                ...state,
                getReturnOrderSuccess: true,
                getReturnOrderData: action.payload?.data?.data?.data,
                getReturnOrderCount: action.payload?.data?.data?.meta?.total,
                getReturnOrderFailure: false,
            };
        }
        case 'GET_RETURN_ORDER_FAILURE': {
            return {
                ...state,
                getReturnOrderFailure: true,
                getReturnOrderMetaMessage: action.payload?.data?.data?.meta?.message,
                getReturnOrderSuccess: false,
            };
        }
        case 'RESET_GET_RETURN_ORDER': {
            return {
                ...state,
                getReturnOrderSuccess: false,
                getReturnOrderFailure: false,
                getReturnOrderData: [],
                getReturnOrderMetaMessage: null,
            };
        }

        //Get All
        case 'GETALL_RETURN_ORDER_SUCCESS': {
            return {
                ...state,
                getAllReturnOrderSuccess: true,
                getAllReturnOrderData: action.payload?.data?.data?.data,
                getAllReturnOrderFailure: false,
            };
        }
        case 'GETALL_RETURN_ORDER_FAILURE': {
            return {
                ...state,
                getAllReturnOrderFailure: true,
                getReturnOrderMetaMessage: action.payload?.data?.data?.meta?.message,
                getAllReturnOrderSuccess: false,
            };
        }
        case 'RESET_GETALL_RETURN_ORDER': {
            return {
                ...state,
                getAllReturnOrderSuccess: false,
                getAllReturnOrderFailure: false,
                getAllReturnOrderData: [],
                getReturnOrderMetaMessage: null,
            };
        }

        case 'CREATE_RETURN_ORDER_SUCCESS': {
            return {
                ...state,
                createReturnOrderSuccess: true,
                createReturnOrderData: action.payload?.data?.data?.data,
                getReturnOrderMetaMessage: action.payload?.data?.data?.meta?.message,
                createReturnOrderFailure: false,
            };
        }
        case 'CREATE_RETURN_ORDER_FAILURE': {
            return {
                ...state,
                createReturnOrderFailure: true,
                getReturnOrderMetaMessage: action.payload?.data?.data?.meta?.message,
                createReturnOrderSuccess: false,
            };
        }
        case 'RESET_CREATE_RETURN_ORDER': {
            return {
                ...state,
                createReturnOrderSuccess: false,
                createReturnOrderFailure: false,
                createReturnOrderData: null,
                getReturnOrderMetaMessage: null,
            };
        }

        case 'UPDATE_RETURN_ORDER_SUCCESS': {
            return {
                ...state,
                updateReturnOrderSuccess: true,
                updateReturnOrderData: action.payload?.data?.data?.data,
                getReturnOrderMetaMessage: action.payload?.data?.data?.meta?.message,
                updateReturnOrderFailure: false,
            };
        }
        case 'UPDATE_RETURN_ORDER_FAILURE': {
            return {
                ...state,
                updateReturnOrderFailure: true,
                getReturnOrderMetaMessage: action.payload?.data?.data?.meta?.message,
                updateReturnOrderSuccess: false,
            };
        }
        case 'RESET_UPDATE_RETURN_ORDER': {
            return {
                ...state,
                updateReturnOrderSuccess: false,
                updateReturnOrderFailure: false,
                updateReturnOrderData: null,
                getReturnOrderMetaMessage: null,
            };
        }

        case 'DELETE_RETURN_ORDER_SUCCESS': {
            return {
                ...state,
                deleteReturnOrderSuccess: true,
                getReturnOrderMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteReturnOrderFailure: false,
            };
        }
        case 'DELETE_RETURN_ORDER_FAILURE': {
            return {
                ...state,
                deleteReturnOrderFailure: true,
                getReturnOrderMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteReturnOrderSuccess: false,
            };
        }
        case 'RESET_DELETE_RETURN_ORDER': {
            return {
                ...state,
                deleteReturnOrderSuccess: false,
                deleteReturnOrderFailure: false,
                getReturnOrderMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
